import { PowerPlugBatteryOutlineIcon } from './PowerPlugBatteryOutlineIcon';

/**
 * author: Jeff Anders
 * id 936AF163-1DC9-4F38-8B7E-5F165695F56C
 * name power-plug-battery-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/power-plug-battery-outline.svg
 * tags
 * - Home Automation 
 * - Battery 
 */
export const BatteryBackupOutlineIcon = PowerPlugBatteryOutlineIcon;
export default BatteryBackupOutlineIcon